import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import api from 'services/api/api';
interface ICheckExistsRestrictedPlanProps {
	cycleId: number | string;
}
export const checkExistsRestrictedPlan = async ({
	cycleId,
}: ICheckExistsRestrictedPlanProps): Promise<boolean> => {
	const response: AxiosResponse<boolean> = await api.get(
		'/restricted-plan/exists-by-cycle',
		{
			params: { cycle_id: cycleId },
		}
	);
	return response.data;
};
export const useExistsRestrictedPlan = (cycleId: number | string) => {
	return useQuery<boolean>({
		queryKey: ['restrictedPlan-exists-byId', cycleId],
		queryFn: () => checkExistsRestrictedPlan({ cycleId }),
		enabled: !!cycleId,
		refetchOnWindowFocus: false,
	});
};
